import useAppState from '@hooks/useAppState'
import { useCallback, useEffect } from 'react'

function useAppLoader(isLoading: boolean = true) {
  const [, dispatchAppState] = useAppState()

  const setLoaderState = useCallback(
    (isLoading: boolean) => {
      dispatchAppState({
        payload: {
          value: isLoading,
        },
        type: 'displayLoader',
      })
    },
    [dispatchAppState],
  )

  useEffect(() => {
    if (isLoading) {
      setLoaderState(true)
      return () => setLoaderState(false)
    }

    return undefined
  }, [isLoading, setLoaderState])
}

export default useAppLoader
